module.exports = __webpack_public_path__ + "static/event-1-6848f0a71d18878a62f60377f60a9377.mp4";